import React, { useEffect, useState } from 'react';
import { Modal, Select, Checkbox, Row, Col, Input, Form, DatePicker, Button } from 'antd';
import { connect } from 'react-redux';
import { createCampaign } from '../../store/action/business/CampaignAction';
import moment from 'moment';
import { createLead } from '../../store/action/admin/LeadAdminAction';
import OpenNotification from '../../utils/OpenNotification';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import { width } from '@mui/system';

const { Option } = Select;

const ManualLeadsModal = (props) => {
  const [visible, setVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const [amount, setAmount] = useState();
  const [provinceId, setProvinceId] = useState();
  const [longDistanceLeads, setLongDistanceLeads] = useState(false);
  const [provinces, setProvinces] = useState([]);
  const [form] = Form.useForm(); 
  const [value, setValue] = React.useState('one');
  
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };



    useEffect(() => {
      const fetchProvinces = async () => {
        try {
          const response = await fetch('https://stageapicanada.blaccdot.com/masters/location/country-based-province/3');
          const result = await response.json();
  
          if (result.data && result.data.locationmaster) {
            setProvinces(result.data.locationmaster);
          }
        } catch (error) {
          console.error('Error fetching provinces:', error);
        }
      };
  
      fetchProvinces();
    }, []);
  

  const handleOk = () => {
    setLoading(true);
    // perform Validations

    let data = {
      provinceId,
      amount,
      longDistanceLeads
    };

    props.createLead_(data);
    setLoading(true);
  };

  useEffect(() => {
    if (props.createLead) {
      if (props.createLead.message === "Leads gathered successfully") {
        OpenNotification("success", "Success", "Lead Created Successfully");
        setVisible(false);
        setLoading(false);
        props.closeModal();
        form.resetFields();
      }
    }
  }, [props.createLead]);

  const handleCancel = () => {
    setVisible(false);
    props.closeModal();
    form.resetFields();
  };

    const onFinish = (values) => {
        const data = {
            provinceName: values.provinceName, 
            // provinceId: values.provinceId,
            leadType:"Organic",
            country: "Canada",
            category:3,
            leadData: {
                name: values.name,
                email: values.email,
                phone: values.phone,
                propertyType: values.propertyType,
                propertySize: values.propertySize,
                movingDate: values.movingDate,
                movingFrom: values.movingFrom,
                movingTo: values.movingTo,
                timeToCall: values.timeToCall,
            },
            source: 'manual'
        }
        props.createLead_(data);
        form.resetFields();
    }

  useEffect(() => {
    setVisible(props.visible);
  }, [props.visible]);



  return (
    <>
   <Modal
      title="Add Manual Leads"
      open={visible}
      footer={null} closable={false}
      width="700px" >
      <Tabs value={value} onChange={handleChange} textColor="primary" indicatorColor="primary" aria-label="secondary tabs example" >
        <Tab value="one" label="Movers" />
        <Tab value="two" label="Health Care" />
        <Tab value="three" label="Financial Service" />
        <Tab value="four" label="Manufacturing" />
        <Tab value="five" label="Real Estate" />
        <Tab value="six" label="E-Commerce" />
      </Tabs>

      {value ==='one' && (
        <Box sx={{ p: 3 }}>
          <Form form={form} name="basic" style={{marginTop:'30px'}}
            initialValues={{remember: true}}
             onFinish={onFinish}
            onFinishFailed={()=>{}}
            autoComplete="off">
            <Row gutter={16}>
                <Col span={12}>
                    <Form.Item 
                        label="Lead Province:"
                        name="provinceName"
                        rules={[
                            {
                                required: true,
                                message: 'Please enter value',
                            },
                        ]}>
                        <Select placeholder="Select Province">
                        {provinces.map((province) => (
                                <Option key={province.provinceId} value={province.locationName}>
                                {province.locationName}
                                </Option>
                            ))}  
                        </Select>
                    </Form.Item>
                    <Form.Item
                        label="Email:"
                        name="email"
                        rules={[
                            {
                                required: true,
                                message: 'Please enter Email',
                                type: 'email'
                            },
                        ]}
>
                        <Input type='email' />
                    </Form.Item>
                    <Form.Item
                        label="Property Type:"
                        name="propertyType"
                        rules={[
                            {
                                required: true,
                                message: 'Please enter Type',
                            },
                        ]}
                    >
                        <Input />
                    </Form.Item>
                    <Form.Item
                        label="Moving date"
                        name="movingDate"
                        getValueFromEvent={(onChange) => moment(onChange).format('YYYY-MM-DD')}
                        getValueProps={(i) => moment(i)}
                        rules={[
                            {
                            required: true,
                            message: <p> This field is required</p>,
                            },
                        ]}
                        >
                        <DatePicker format='YYYY-MM-DD' />
                    </Form.Item>
                    <Form.Item
                        label="Moving From:"
                        name="movingFrom"
                        rules={[
                            {
                                required: true,
                                message: 'Please enter Moving from',
                            },
                        ]}
                    >
                        <Input />
                    </Form.Item>
                </Col>
                <Col span={12}>
                    <Form.Item
                        label="Name"
                        name="name"
                        rules={[
                            {
                                required: true,
                                message: 'Please enter name',
                            },
                        ]}
                    >
                        <Input />
                    </Form.Item>
                    <Form.Item
                        label="Phone"
                        name="phone"
                        rules={[
                            {
                                required: true,
                                message: 'Please enter number',
                            },
                        ]}
                    >
                        <Input />
                    </Form.Item>
                    <Form.Item
                        label="Property Size:"
                        name="propertySize"
                        rules={[
                            {
                                required: true,
                                message: 'Please enter propertySize',
                            },
                        ]}
                    >
                        <Input />
                    </Form.Item>
                    <Form.Item
                        label="Time to call:"
                        name="timeToCall"
                        rules={[
                            {
                                required: true,
                                message: 'Please enter time',
                            },
                        ]}
                    >
                        <Input />
                    </Form.Item>
                    <Form.Item
                        label="Moving To:"
                        name="movingTo"
                        rules={[
                            {
                                required: true,
                                message: 'Please enter move to',
                            },
                        ]}
                    >
                        <Input />
                    </Form.Item>
                    <Form.Item style={{ textAlign: 'end'}}>
              {/* Save Button */}
              <Button type="primary" htmlType="submit" onClick={() => form.submit()} >
                Save Lead
              </Button>

              {/* Cancel Button */}
              <Button style={{ marginLeft: 8 }} onClick={handleCancel} >
                Cancel
              </Button>
            </Form.Item>
                </Col>
            </Row>
          </Form>
        </Box>
      )}
      {value === 'two' && (
        <Box sx={{p:3}}>
            <img style={{width:'100%'}} src="https://i.pinimg.com/originals/88/26/62/88266293befad983ddd0197b09bf64af.gif" alt='main' />
        </Box>
      )}
      {value === 'three' && (
        <Box sx={{p:3}}>
            <img style={{width:'100%'}} src="https://i.pinimg.com/originals/88/26/62/88266293befad983ddd0197b09bf64af.gif" alt='main' />
        </Box>
      )}
      {value === 'four' && (
        <Box sx={{p:3}}>
            <img style={{width:'100%'}} src="https://i.pinimg.com/originals/88/26/62/88266293befad983ddd0197b09bf64af.gif" alt='main' />
        </Box>
      )}
      {value === 'five' && (
        <Box sx={{p:3}}>
            <img style={{width:'100%'}} src="https://i.pinimg.com/originals/88/26/62/88266293befad983ddd0197b09bf64af.gif" alt='main' />
        </Box>
      )}
      {value === 'six' && (
        <Box sx={{p:3}}>
            <img style={{width:'100%'}} src="https://i.pinimg.com/originals/88/26/62/88266293befad983ddd0197b09bf64af.gif" alt='main' />
        </Box>
      )}

   
    </Modal>

      {/* <Modal title="Add Manual Leads" open={visible}
        onOk={handleOk} onCancel={handleCancel} footer={false} width="700px" >
        <Form  form={form} 
            name="basic"
            initialValues={{
                remember: true,
            }}
            onFinish={onFinish}
            onFinishFailed={()=>{}}
            autoComplete="off">
            <Row gutter={16}>
                <Col span={12}>
                    <Form.Item 
                        label="Lead Province:"
                        name="provinceName"
                        rules={[
                            {
                                required: true,
                                message: 'Please enter value',
                            },
                        ]}>
                        <Select placeholder="Select Province">
                        {provinces.map((province) => (
                                <Option key={province.provinceId} value={province.locationName}>
                                {province.locationName}
                                </Option>
                            ))}  
                        </Select>
                    </Form.Item>
                    <Form.Item
                        label="Email:"
                        name="email"
                        rules={[
                            {
                                required: true,
                                message: 'Please enter Email',
                                type: 'email'
                            },
                        ]}
                    >
                        <Input type='email' />
                    </Form.Item>
                    <Form.Item
                        label="Property Type:"
                        name="propertyType"
                        rules={[
                            {
                                required: true,
                                message: 'Please enter Type',
                            },
                        ]}
                    >
                        <Input />
                    </Form.Item>
                    <Form.Item
                        label="Moving date"
                        name="movingDate"
                        getValueFromEvent={(onChange) => moment(onChange).format('YYYY-MM-DD')}
                        getValueProps={(i) => moment(i)}
                        rules={[
                            {
                            required: true,
                            message: <p> This field is required</p>,
                            },
                        ]}
                        >
                        <DatePicker format='YYYY-MM-DD' />
                    </Form.Item>
                    <Form.Item
                        label="Moving From:"
                        name="movingFrom"
                        rules={[
                            {
                                required: true,
                                message: 'Please enter Moving from',
                            },
                        ]}
                    >
                        <Input />
                    </Form.Item>
                </Col>
                <Col span={12}>
                    <Form.Item
                        label="Name"
                        name="name"
                        rules={[
                            {
                                required: true,
                                message: 'Please enter name',
                            },
                        ]}
                    >
                        <Input />
                    </Form.Item>
                    <Form.Item
                        label="Phone"
                        name="phone"
                        rules={[
                            {
                                required: true,
                                message: 'Please enter number',
                            },
                        ]}
                    >
                        <Input />
                    </Form.Item>
                    <Form.Item
                        label="Property Size:"
                        name="propertySize"
                        rules={[
                            {
                                required: true,
                                message: 'Please enter propertySize',
                            },
                        ]}
                    >
                        <Input />
                    </Form.Item>
                    <Form.Item
                        label="Time to call:"
                        name="timeToCall"
                        rules={[
                            {
                                required: true,
                                message: 'Please enter time',
                            },
                        ]}
                    >
                        <Input />
                    </Form.Item>
                    <Form.Item
                        label="Moving To:"
                        name="movingTo"
                        rules={[
                            {
                                required: true,
                                message: 'Please enter move to',
                            },
                        ]}
                    >
                        <Input />
                    </Form.Item>
                    <Form.Item style={{ textAlign: "end" }}>
                        <Button type="primary" htmlType="submit">
                            Save
                        </Button>
                        </Form.Item>
                </Col>
            </Row>
        </Form>
        <br />
        <br />
      </Modal> */}
    </>
  );
};

const mapStateToProps = state => ({
  createLead: state.createLead.response
})

const mapDispatchToProps = dispatch => ({
  createLead_: (data)=>{
      dispatch(createLead(data));
  }
}) 

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ManualLeadsModal);





// import React, { useEffect, useState } from 'react';
// import { Modal, Select, Checkbox, Row, Col, Input, Form, DatePicker, Button } from 'antd';
// import { connect } from 'react-redux';
// import { createCampaign } from '../../store/action/business/CampaignAction';
// import moment from 'moment';
// import { createLead } from '../../store/action/admin/LeadAdminAction';
// import OpenNotification from '../../utils/OpenNotification';

// const { Option } = Select;

// const ManualLeadsModal = (props) => {
//   const [visible, setVisible] = useState(false);
//   const [loading, setLoading] = useState(false);
//   const [amount, setAmount] = useState();
//   const [provinceId, setProvinceId] = useState();
//   const [longDistanceLeads, setLongDistanceLeads] = useState(false);

//   const handleOk = () => {
//     setLoading(true);
//     // perform Validations

//     let data = {
//       provinceId,
//       amount,
//       longDistanceLeads
//     };

//     props.createLead_(data);
//   };

//   useEffect(() => {
//     if (props.createLead) {
//       if (props.createLead.message === "Leads gathered successfully") {
//         OpenNotification("success", "Success", "Lead Created Successfully");
//         setVisible(false);
//         setLoading(false);
//         props.closeModal();
//       }
//     }
//   }, [props.createLead]);

//   const handleCancel = () => {
//     setVisible(false);
//     props.closeModal()
//   };

//     const onFinish = (values) => {
//         const data = {
//             provinceName: values.provinceId,
//             // provinceId: values.provinceId,
//             leadType:"Organic",
//             country: "United Kingdom",
//             leadData: {
//                 name: values.name,
//                 email: values.email,
//                 phone: values.phone,
//                 propertyType: values.propertyType,
//                 propertySize: values.propertySize,
//                 movingDate: values.movingDate,
//                 movingFrom: values.movingFrom,
//                 movingTo: values.movingTo,
//                 timeToCall: values.timeToCall,
//             },
//             source: 'manual'
//         }
//         props.createLead_(data);
//     }



//   useEffect(() => {
//     setVisible(props.visible);
//   }, [props.visible]);

//   return (
//     <>
//       <Modal
//         title="Add Manual Leads"
//         open={visible}
//         onOk={handleOk}
//         onCancel={handleCancel}
//         footer={false}
//         width="700px"
//       >
//         <Form
//             name="basic"
//             initialValues={{
//                 remember: true,
//             }}
//             onFinish={onFinish}
//             onFinishFailed={()=>{}}
//             autoComplete="off"
//         >
//             <Row gutter={16}>
//                 <Col span={12}>
//                     <Form.Item
//                         label="Lead Province:"
//                         name="provinceId"
//                         rules={[
//                             {
//                                 required: true,
//                                 message: 'Please enter provinceId',
//                             },
//                         ]}>
//                         <Select placeholder="Select Province">
//                             <Option value="1">Alberta</Option>
//                             <Option value="BC">British Columbia</Option>
//                             <Option value="3">Manitoba</Option>
//                             <Option value="NB">New Brunswick</Option>
//                             <Option value="NL">Newfoundland and Labrador</Option>
//                             <Option value="NS">Nova Scotia</Option>
//                             <Option value="NT">Northwest Territories</Option>
//                             <Option value="NU">Nunavut</Option>
//                             <Option value="2">Ontario</Option>
//                             <Option value="PE">Prince Edward Island</Option>
//                             <Option value="QC">Quebec</Option>
//                             <Option value="SK">Saskatchewan</Option>
//                             <Option value="YT">Yukon</Option>
//                         </Select>
//                     </Form.Item>
//                     <Form.Item
//                         label="Email:"
//                         name="email"
//                         rules={[
//                             {
//                                 required: true,
//                                 message: '!!!Please enter value',
//                                 type: 'email'
//                             },
//                         ]}
//                     >
//                         <Input type='email' />
//                     </Form.Item>
//                     <Form.Item
//                         label="Property Type:"
//                         name="propertyType"
//                         rules={[
//                             {
//                                 required: true,
//                                 message: '!!!Please enter value',
//                             },
//                         ]}
//                     >
//                         <Input />
//                     </Form.Item>
//                     <Form.Item
//                         label="Moving date"
//                         name="movingDate"
//                         getValueFromEvent={(onChange) => moment(onChange).format('YYYY-MM-DD')}
//                         getValueProps={(i) => moment(i)}
//                         rules={[
//                             {
//                             required: true,
//                             message: <p> This field is required</p>,
//                             },
//                         ]}
//                         >
//                         <DatePicker format='YYYY-MM-DD' />
//                     </Form.Item>
//                     <Form.Item
//                         label="Moving From:"
//                         name="movingFrom"
//                         rules={[
//                             {
//                                 required: true,
//                                 message: '!!!Please enter value',
//                             },
//                         ]}
//                     >
//                         <Input />
//                     </Form.Item>
//                 </Col>
//                 <Col span={12}>
//                     <Form.Item
//                         label="Name"
//                         name="name"
//                         rules={[
//                             {
//                                 required: true,
//                                 message: '!!!Please enter value',
//                             },
//                         ]}
//                     >
//                         <Input />
//                     </Form.Item>
//                     <Form.Item
//                         label="Phone"
//                         name="phone"
//                         rules={[
//                             {
//                                 required: true,
//                                 message: '!!!Please enter value',
//                             },
//                         ]}
//                     >
//                         <Input />
//                     </Form.Item>
//                     <Form.Item
//                         label="Property Size:"
//                         name="propertySize"
//                         rules={[
//                             {
//                                 required: true,
//                                 message: '!!!Please enter value',
//                             },
//                         ]}
//                     >
//                         <Input />
//                     </Form.Item>
//                     <Form.Item
//                         label="Time to call:"
//                         name="timeToCall"
//                         rules={[
//                             {
//                                 required: true,
//                                 message: '!!!Please enter value',
//                             },
//                         ]}
//                     >
//                         <Input />
//                     </Form.Item>
//                     <Form.Item
//                         label="Moving To:"
//                         name="movingTo"
//                         rules={[
//                             {
//                                 required: true,
//                                 message: '!!!Please enter value',
//                             },
//                         ]}
//                     >
//                         <Input />
//                     </Form.Item>
//                     <Form.Item style={{ textAlign: "end" }}>
//                         <Button type="primary" htmlType="submit">
//                             Save
//                         </Button>
//                         </Form.Item>
//                 </Col>
//             </Row>
//         </Form>
//         <br />
//         <br />
//       </Modal>
//     </>
//   );
// };

// const mapStateToProps = state => ({
//   createLead: state.createLead.response
// })

// const mapDispatchToProps = dispatch => ({
//   createLead_: (data)=>{
//       dispatch(createLead(data));
//   }
// }) 

// export default connect(
//   mapStateToProps,
//   mapDispatchToProps
// )(ManualLeadsModal);